//Componentes generales
import React, { useEffect, useState } from "react";

import moment from "moment";

//Permisos
import {
  EDITAR_REQUERIMIENTO,
  MODIFICAR_ESTADO_NOTA_PEDIDO,
  REENVIO_REQ_SERVIDOR,
} from "../../utils/permisos";

//Tipos de Prioridades
import { PRIORITYOUT } from "../../utils/priority";
import Swal from "sweetalert2";

const RenderRow = ({
  currentUser,
  index,
  style,
  listTDoc,
  filter,
  checkPermisos,
  cambiarEstado,
  editar,
  verDetalles,
  statesNEviables,
  sendToAPI,
  guardarEstado,
  cerrar,
  disabledElements,
}) => {
  const [currentLista, setCurrentLista] = useState(listTDoc ? listTDoc : []);
  const [disabledElementsReq, setDisabledElementsReq] =
    useState(disabledElements);

  useEffect(() => {
    setDisabledElementsReq(disabledElements);
  }, [disabledElements]);

  const saveReq = async (r) => {
    try {
      const resp = await guardarEstado(r, r.state, r.observStateChange);

      if (resp.data && resp.data.state == "PENDIENTE") {
        Swal.fire(
          "Estado: " + r.state,
          "El Estado fue Enviado Correctamente <br> <strong>" +
            resp.message +
            " </strong> ",
          "success"
        );
      } else if (resp.data) {
        Swal.fire({
          icon: "error",
          title: "Estado: " + r.state,
          text: "El Estado no fue Enviado. Por favor, vuelve a intentarlo más tarde. ",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Estado: " + r.state,
          text: resp,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error al enviar el estado",
        text: "Hubo un problema al intentar enviar el estado. Intenta nuevamente más tarde.",
      });
      console.error("Error en la solicitud de guardar estado:", error);
    } finally {
      cerrar(null);
    }
  };

  /*
        if(checkPermisos(VER_TODOS_NOTAS_PEDIDO)){
            currentLista = listTDoc;
        }else{
            currentLista = listTDoc.filter(r => r.userName.includes(currentUser.userName));
        }*/

  if (currentLista && currentLista.length > 0) {
    if (filter === "") {
      return (
        <div style={style}>
          <div className="container-r-list-item">
            <div className="container-r-list-item-header">
              <div className="r-list-item-header-clave">
                <div>
                  {currentLista[index].tDocCodFor +
                    " - " +
                    currentLista[index].tDocNroFor}
                </div>
              </div>
              <div className="r-list-item-header-title">
                {currentLista[index].title}
              </div>
              <div className="margin-right-r">
                <div
                  className={
                    currentLista[index].priority === 0
                      ? "r-list-item-header-priority-media"
                      : currentLista[index].priority === 1
                      ? "r-list-item-header-priority-alta"
                      : "r-list-item-header-priority-urgente"
                  }
                >
                  {PRIORITYOUT[currentLista[index].priority]}
                </div>
              </div>
            </div>
            <div className="container-r-list-item-details">
              <div className="r-list-item-details-clave">
                {currentLista[index].state}
              </div>
              <div>
                <div className="r-list-item-details-title">
                  Fecha de Movimiento:{" "}
                  {moment.utc(currentLista[index].fchMov).format("DD-MM-YYYY")}
                </div>
                <div className="r-list-item-details-title">
                  Alta:{" "}
                  {moment
                        .utc(currentLista[index].fecAlt)
                        .format("DD-MM-YYYY HH:mm")}
                </div>
              </div>
              <div>
                <div>
                  <div className="r-list-item-details-title"></div>
                  <div className="r-list-item-details-title">
                    Entrega:{" "}
                    {moment
                      .utc(currentLista[index].deliveryDate)
                      .format("DD-MM-YYYY")}
                  </div>
                  {currentLista[index].usrAut && (
                    <div className="r-list-item-details-title">
                      Autorizado por: {currentLista[index].usrAut}
                    </div>
                  )}
                </div>
              </div>
              <div style={{ marginRight: "20px" }}>
                <div className="r-list-item-details-title">
                  Última modificación:{" "}
                  {moment
                        .utc(currentLista[index].fecMod)
                        .format("DD-MM-YYYY")}
                </div>
                <div className="r-list-item-details-title">
                  Usuario: {currentLista[index].userName}
                </div>
              </div>
            </div>
            <div className="container-r-list-item-btn">
              {checkPermisos(MODIFICAR_ESTADO_NOTA_PEDIDO) &&
                (currentLista[index].state !== "AUTORIZADO") && (
                  <div
                    className={`${"r-list-item-btn-A"} ${
                      disabledElementsReq ? "navbar-container-disabled" : ""
                    }`}
                    onClick={() =>
                      !disabledElementsReq
                        ? cambiarEstado(currentLista[index])
                        : null
                    }
                  >
                    Modificar Estado
                  </div>
                )}
              {checkPermisos(EDITAR_REQUERIMIENTO) &&
                (currentLista[index].state !== "AUTORIZADO" && currentLista[index].state !== "RECHAZADO") &&
                currentLista[index].enviado === false && (
                  <div
                    className={`${"r-list-item-btn-A"} ${
                      disabledElementsReq ? "navbar-container-disabled" : ""
                    }`}
                    onClick={() =>
                      !disabledElementsReq ? editar(currentLista[index]) : null
                    }
                  >
                    Editar
                  </div>
                )}
              <div
                className={`${"r-list-item-btn-A"} ${
                  disabledElementsReq ? "navbar-container-disabled" : ""
                }`}
                onClick={() =>
                  !disabledElementsReq ? verDetalles(currentLista[index]) : null
                }
              >
                Detalles
              </div>
            </div>
            {checkPermisos(REENVIO_REQ_SERVIDOR) &&
              !statesNEviables.includes(currentLista[index].state) &&
              currentLista[index].enviado === false && (
                <div
                  className={`${"container-resend"} ${
                    disabledElementsReq ? "navbar-container-disabled" : ""
                  }`}
                  onClick={() =>
                    !disabledElementsReq ? sendToAPI(currentLista[index]) : null
                  }
                >
                  {"Enviar >>>"}
                </div>
              )}
          </div>
        </div>
      );
    } else {
      const req_filters = currentLista.filter(
        (r) =>
          r.title.toLowerCase().includes(filter.toLowerCase()) ||
          (
            r.tDocCodFor.toLowerCase() +
            " - " +
            r.tDocNroFor.toString().toLowerCase()
          ).includes(filter.toLowerCase()) ||
          r.tDocNroFor.toString().toLowerCase().includes(filter.toLowerCase())
      );
      return (
        <div style={style}>
          <div className="container-r-list-item">
            <div className="container-r-list-item-header">
              <div className="r-list-item-header-clave">
                <div>
                  {req_filters[index].tDocCodFor +
                    " - " +
                    req_filters[index].tDocNroFor}
                </div>
              </div>
              <div className="r-list-item-header-title">
                {req_filters[index].title}
              </div>
              <div className="margin-right-r">
                <div
                  className={
                    req_filters[index].priority === 0
                      ? "r-list-item-header-priority-media"
                      : req_filters[index].priority === 1
                      ? "r-list-item-header-priority-alta"
                      : "r-list-item-header-priority-urgente"
                  }
                >
                  {PRIORITYOUT[req_filters[index].priority]}
                </div>
              </div>
            </div>
            <div className="container-r-list-item-details">
              <div className="r-list-item-details-clave">
                {req_filters[index].state}
              </div>
              <div>
                <div className="r-list-item-details-title">
                  Fecha de Movimiento:{" "}
                  {moment.utc(req_filters[index].fchMov).format("DD-MM-YYYY")}
                </div>
                <div className="r-list-item-details-title">
                  Alta:{" "}
                  { moment
                        .utc(req_filters[index].fecAlt)
                        .format("DD-MM-YYYY HH:mm")
                    }
                </div>
              </div>
              <div>
                <div>
                  <div className="r-list-item-details-title"></div>
                  <div className="r-list-item-details-title">
                    Entrega:{" "}
                    {moment
                      .utc(req_filters[index].deliveryDate)
                      .format("DD-MM-YYYY")}
                  </div>
                  {req_filters[index].usrAut && (
                    <div className="r-list-item-details-title">
                      Autorizado por: {req_filters[index].usrAut}
                    </div>
                  )}
                </div>
              </div>
              <div style={{ marginRight: "20px" }}>
                <div className="r-list-item-details-title">
                  Última modificación:{" "}
                  {moment
                        .utc(req_filters[index].fecMod)
                        .format("DD-MM-YYYY")}
                </div>
                <div className="r-list-item-details-title">
                  Usuario: {req_filters[index].userName}
                </div>
              </div>
            </div>
            <div className="container-r-list-item-btn">
              {checkPermisos(MODIFICAR_ESTADO_NOTA_PEDIDO) &&
                (req_filters[index].state !== "AUTORIZADO") && (
                  <div
                    className={`${"r-list-item-btn-A"} ${
                      disabledElementsReq ? "navbar-container-disabled" : ""
                    }`}
                    onClick={() =>
                      !disabledElementsReq
                        ? cambiarEstado(req_filters[index])
                        : null
                    }
                  >
                    Modificar Estado
                  </div>
                )}
              {checkPermisos(EDITAR_REQUERIMIENTO) &&
                (req_filters[index].state !== "AUTORIZADO" && req_filters[index].state !== "RECHAZADO") &&
                req_filters[index].enviado === false && (
                  <div
                    className={`${"r-list-item-btn-A"} ${
                      disabledElementsReq ? "navbar-container-disabled" : ""
                    }`}
                    onClick={() =>
                      !disabledElementsReq ? editar(req_filters[index]) : null
                    }
                  >
                    Editar
                  </div>
                )}
              <div
                className={`${"r-list-item-btn-A"} ${
                  disabledElementsReq ? "navbar-container-disabled" : ""
                }`}
                onClick={() =>
                  !disabledElementsReq ? verDetalles(req_filters[index]) : null
                }
              >
                Detalles
              </div>
            </div>
            {checkPermisos(REENVIO_REQ_SERVIDOR) &&
              !statesNEviables.includes(req_filters[index].state) &&
              req_filters[index].enviado === false && (
                <div
                  className={`${"container-resend"} ${
                    disabledElementsReq ? "navbar-container-disabled" : ""
                  }`}
                  onClick={() =>
                    !disabledElementsReq ? sendToAPI(req_filters[index]) : null
                  }
                >
                  {"Enviar >>>"}
                </div>
              )}
          </div>
        </div>
      );
    }
  }
};

export default RenderRow;
